import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faExclamationTriangle, faChartLine, faMap, faList, faArrowLeft, faFilePdf, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './styleSheets/TopNavBar.css';

const TopNavBar = ({ siteName, selectedDate }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (pathStart) => location.pathname.startsWith(pathStart);

  return (
    <nav className="top-nav-bar">
      <div className="left-nav">
        <button
          className="site-list-btn"
          onClick={() => navigate('/')}
        >
          <FontAwesomeIcon icon={faList} />
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
      </div>
      <ul>
        <li>
          <button
            className={isActive('/site-dashboard') ? 'active-nav' : ''}
            onClick={() =>
              navigate(`/site-dashboard/${encodeURIComponent(siteName)}/${encodeURIComponent(selectedDate)}`)
            }
          >
            <FontAwesomeIcon icon={faHome} />
            <span> Overview</span>
          </button>
        </li>

        <li>
          <button
            className={isActive('/revenue-analysis') ? 'active-nav' : ''}
            onClick={() =>
              navigate(`/revenue-analysis/${encodeURIComponent(siteName)}/${encodeURIComponent(selectedDate)}`)
            }
          >
            <FontAwesomeIcon icon={faChartLine} />
            <span> Revenue Analysis</span>
          </button>
        </li>

        <li>
          <button
            className={isActive('/fault-data') ? 'active-nav' : ''}
            onClick={() =>
              navigate(`/fault-data/${encodeURIComponent(siteName)}/${encodeURIComponent(selectedDate)}`)
            }
          >
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <span> Fault Data</span>
          </button>
        </li>

        <li>
          <button
            className={isActive('/map') ? 'active-nav' : ''}
            onClick={() =>
              navigate(`/map/${encodeURIComponent(siteName)}/${encodeURIComponent(selectedDate)}`)
            }
          >
            <FontAwesomeIcon icon={faMap} />
            <span> Map Overview</span>
          </button>
        </li>
      </ul>

      <div className="right-nav">
        <button
          className="nav-bar-export-btn"
          onClick={() =>
            navigate(`/export/${encodeURIComponent(siteName)}/${encodeURIComponent(selectedDate)}`)
          }
        >
          <FontAwesomeIcon icon={faArrowRight} />
          <FontAwesomeIcon icon={faFilePdf} />
        </button>
      </div>
    </nav>
  );
};

export default TopNavBar;
